import React, { useState } from 'react';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <img 
                  src={logo} 
                  alt="Logo da Valiosaliada" 
                  className="h-12 w-auto sm:h-16"
                />
              </div>
              
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#inicio" className="text-gray-700 hover:text-green-600">Início</a>
            <a href="#servicos" className="text-gray-700 hover:text-green-600">Serviços</a>
            <a href="#projetos" className="text-gray-700 hover:text-green-600">Projetos</a>
            <a href="#contato" className="text-gray-700 hover:text-green-600">Contato</a>
          </div>
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsOpen(!isOpen)} 
              className="text-gray-700"
            >
              {isOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white py-4 px-4 border-t">
          <a 
            href="#inicio" 
            className="block py-2 text-gray-700 hover:text-green-600"
            onClick={() => setIsOpen(false)}
          >
            Início
          </a>
          <a 
            href="#servicos" 
            className="block py-2 text-gray-700 hover:text-green-600"
            onClick={() => setIsOpen(false)}
          >
            Serviços
          </a>
          <a 
            href="#projetos" 
            className="block py-2 text-gray-700 hover:text-green-600"
            onClick={() => setIsOpen(false)}
          >
            Projetos
          </a>
          <a 
            href="#contato" 
            className="block py-2 text-gray-700 hover:text-green-600"
            onClick={() => setIsOpen(false)}
          >
            Contato
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;